import { TurboMount } from "turbo-mount"
import { registerComponent } from "turbo-mount/react"
import ReactMountController from "controllers/react_mount_controller"

const turboMount = new TurboMount()

// Takes a nested object structure and registers each function as a component
// "Components.Some.SubComponent" will register "Components/Some/SubComponent"
// in the turboMount registry.

// The `turbo_mount` view helper (via `react_component`) will
// take the dotted path and convert it to the slash path automatically.
// e.g. react_component("Components.Some.SubComponent", { some_prop: "value" })
function registerWithPath(registry) {
  function recurse(currentObj, pathParts = []) {
    for (const key in currentObj) {
      if (Object.prototype.hasOwnProperty.call(currentObj, key)) {
        const value = currentObj[key]
        const currentPath = [...pathParts, key]

        if (typeof value === "function") {
          const pathString = currentPath.join("/")
          registerComponent(turboMount, pathString, value, ReactMountController)
        } else if (typeof value === "object" && value !== null) {
          recurse(value, currentPath)
        }
      }
    }
  }

  recurse(registry)
}

export { turboMount, registerWithPath }
